/**
 * Mouse Selection module
 * @constructor
 * @param {array} selectableFiles - list of selectable elements
 * @param {array} selectionContainer - selection container element
 * @param {function} selected - selected file function
 * @param {function} unSelected - unselected file function
 * @param {function} onBeforeStart - call function onBeforeStart
 * @param {function} onBeforeEnd - call function onBeforeEnd
 */

/**
 * add this link/css to html file
 *   <link rel="stylesheet" type="text/css" href="/WebInterface/new-ui/modules/mouse-selection/mouse-selection.css" />
 */

import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export default class MouseSelection {
  constructor({
    selectableFiles,
    selectionContainer,
    selected,
    unSelected,
    onBeforeStart = () => {},
    onBeforeEnd = () => {},
  }) {
    this.selectableFiles = selectableFiles;
    this.selectionContainer = selectionContainer;
    this.selected = selected;
    this.unSelected = unSelected;
    this.onBeforeStart = onBeforeStart;
    this.onBeforeEnd = onBeforeEnd;
    this.selectionRectangle = document.createElement("div");
    this.selectionRectangle.classList.add("mouse-selection-rectangle");
    this.init();
  }

  init = () => {
    let isMouseDown = false;
    let originalOffsetX,
      originalOffsetY,
      originalClientX,
      originalClientY,
      initContainerTop,
      originalContainerTop,
      originalContainerLeft;

    this.selectionContainer.appendChild(this.selectionRectangle);

    const mouseDownHandle = (e) => {
      if (
        e.target.closest(".grid-item") ||
        e.target.closest(".table-tr") ||
        e.which !== 1
      ) {
        return;
      }

      this.onBeforeStart();

      isMouseDown = true;
      originalOffsetX = e.offsetX;
      originalOffsetY = e.offsetY;

      originalClientX = e.clientX;
      originalClientY = e.clientY;
      const fileContainer =
        this.selectionContainer.children[0].getBoundingClientRect();
      initContainerTop = fileContainer.top;
    };

    const mouseMoveHandle = (e) => {
      if (!isMouseDown) return;

      _$(this.selectionRectangle).show();

      const fileContainer =
        this.selectionContainer.children[0].getBoundingClientRect();

      originalContainerTop = fileContainer.top;
      originalContainerLeft = fileContainer.left;

      const width = Math.abs(originalClientX - e.clientX);
      const height =
        Math.abs(originalClientY - e.clientY) +
        Math.abs(initContainerTop - originalContainerTop);

      // Round dynamic values to nearest 10px for utility class compatibility
      const roundedWidth = Math.round(Math.abs(width) / 10) * 10;
      const roundedHeight = Math.round(Math.abs(height) / 10) * 10;
      const roundedLeft = Math.round(Math.min(e.clientX - originalContainerLeft, originalOffsetX) / 10) * 10;
      const roundedTop = Math.round(Math.min(e.clientY - originalContainerTop, originalOffsetY) / 10) * 10;

      _$(this.selectionRectangle).css("width", `${roundedWidth}px`);
      _$(this.selectionRectangle).css("height", `${roundedHeight}px`);
      _$(this.selectionRectangle).css("left", `${roundedLeft}px`);
      _$(this.selectionRectangle).css("top", `${roundedTop}px`);

      this.selectableFiles.forEach((file) => {
        const itemRect = file.getBoundingClientRect();
        const selectionRect = this.selectionRectangle.getBoundingClientRect();
        if (
          selectionRect.left < itemRect.right &&
          selectionRect.right > itemRect.left &&
          selectionRect.top < itemRect.bottom &&
          selectionRect.bottom > itemRect.top
        ) {
          this.selected(file, e);
        } else {
          this.unSelected(file);
        }
      });
    };

    const mouseUpHandle = () => {
      isMouseDown = false;
      // Check if rectangle is visible by checking computed style
      const computedStyle = window.getComputedStyle(this.selectionRectangle);
      if (computedStyle.display === "block") {
        _$(this.selectionRectangle).hide();
        _$(this.selectionRectangle).css("width", "");
        _$(this.selectionRectangle).css("height", "");
        _$(this.selectionRectangle).css("top", "");
        _$(this.selectionRectangle).css("left", "");
        this.onBeforeEnd();
      }
    };
    // that.selectionContainer.removeEventListener("mousedown", mouseDownHandle);
    // that.selectionContainer.removeEventListener("mousemove", mouseMoveHandle);
    // document.body.removeEventListener("mouseup", mouseUp);

    this.selectionContainer.addEventListener("mousedown", mouseDownHandle);
    this.selectionContainer.addEventListener("mousemove", mouseMoveHandle);
    document.body.addEventListener("mouseup", mouseUpHandle);
  }
}
